const BreakpointValues = Object.freeze({
    XS: 480,
    SM: 768,
    MD: 1024,
    LG: 1280,
    XL: 1366,
    XXL: 1600,
});
const BreakPointsMedia = Object.freeze({
    XXS: `@media screen and (max-width: ${BreakpointValues.XS - 1}px)`,
    XS: `@media screen and (min-width: ${BreakpointValues.XS}px) and (max-width: ${BreakpointValues.SM - 1}px)`,
    SM: `@media screen and (min-width: ${BreakpointValues.SM}px) and (max-width: ${BreakpointValues.MD - 1}px)`,
    MD: `@media screen and (min-width: ${BreakpointValues.MD}px) and (max-width: ${BreakpointValues.LG - 1}px)`,
    LG: `@media screen and (min-width: ${BreakpointValues.LG}px) and (max-width: ${BreakpointValues.XL - 1}px)`,
    XL: `@media screen and (min-width: ${BreakpointValues.XL}px) and (max-width: ${BreakpointValues.XXL - 1}px)`,
    XXL: `@media screen and (min-width: ${BreakpointValues.XXL}px)`,
});
// For old usage
const ResponsiveWidth = Object.freeze({
    Default: 1600,
    ExtraLarge: 1366,
    Large: 1280,
    Medium: 1024,
    Small: '100%',
});
// For old usage
const BreakPoints = Object.freeze({
    ExtraLarge: 1599,
    Large: 1365,
    Medium: 1279,
    Small: 1023, // ResponsiveWidth.Medium - 1
});

export { BreakPoints, BreakPointsMedia, BreakpointValues, ResponsiveWidth };
